import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';
import api from '../../../api';
import './styles.css';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import showAlert from '../../../components/common/showAlert';

const PaymentForm = ({setShowModal, clearMessage, getSubscriptionStatus, fetchPaymentsList}) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const stripePromise = useStripe();
  const elements = useElements();

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    if (!stripePromise) {
      alert('Stripe Elements are not fully loaded');
      setIsLoading(false);
      return;
    }

    const stripe = await stripePromise;
    const cardNumber = elements.getElement(CardNumberElement);
    const cardExpiry = elements.getElement(CardExpiryElement);
    const cardCvc = elements.getElement(CardCvcElement);

    if (!cardNumber || !cardExpiry || !cardCvc) {
      alert('Stripe Elements are not fully loaded');
      setIsLoading(false);
      return;
    }

    const { token, error } = await stripe.createToken(cardNumber);

    if (error) {
      setError(error.message);
      setIsLoading(false);
    } else {
      const formData = JSON.parse(localStorage.getItem('formData')) || {};
      formData.token = token.id;

      try {        
        const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/renew-subscription`, formData);
        const data = response.data;

        if (data.success) {
           showAlert('success', 'Your subscription has been renewed successfully!');
        } else {
          alert(`Operation failed: ${data.message}`);
          setShowModal(false);
        }
        setIsLoading(false);
        setShowModal(false); // Close modal after successful submission
        dispatch(clearMessage());
        dispatch(getSubscriptionStatus());
        dispatch(fetchPaymentsList(1));
      } catch (err) { console.log(err);
        alert('Error processing payment.');
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="payment-form-container" style={{padding:'0px', maxWidth:'unset'}}>
      <h2 className="payment-title">Pay for renew</h2>
      <form onSubmit={handleFormSubmit} className="payment-form">
        <div className="form-group">
          <label htmlFor="cardNumber">Card Number</label>
          <CardNumberElement id="cardNumber" className="form-control" />
        </div>
        <div className="form-group">
          <label htmlFor="cardExpiry">Card Expiry</label>
          <CardExpiryElement id="cardExpiry" className="form-control" />
        </div>
        <div className="form-group">
          <label htmlFor="cardCvc">Card CVC</label>
          <CardCvcElement id="cardCvc" className="form-control" />
        </div>
        {error && <p className="error-message">{error}</p>}
        <div className="form-group">
          <button type="submit" disabled={isLoading} className="modal-btn-item btn-curve">
            {isLoading ? 'Processing...' : 'Pay Now'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PaymentForm;
